import { Button, CircularProgress } from '@material-ui/core';
import React, { FC } from 'react';

export type Props = {
  /**
   * ボタン押下時に実行される処理
   */
  onClick: VoidFunction;

  /**
   * ローディング中であるかを示す真偽値
   */
  isLoading: boolean;

  /**
   * 販売可能であるかを示す真偽値
   */
  isAvailableForSale: boolean;
};

/**
 * 商品をカートに追加するボタン
 */
const AddToCartButton: FC<Props> = ({
  onClick,
  isLoading,
  isAvailableForSale,
}) => (
  <>
    {isLoading ? (
      <CircularProgress />
    ) : (
      <Button
        onClick={() => onClick()}
        variant="contained"
        color="primary"
        disabled={!isAvailableForSale}
      >
        {isAvailableForSale ? 'カートに追加' : '売り切れ'}
      </Button>
    )}
  </>
);

export default AddToCartButton;
